import http from "@/utils/http";

const $addPress = (data) => http.post('/api/edu/publisher/addPublisher', data); //新增出版社
const $editPress = (data) => http.post('/api/edu/publisher/updatePublisher', data); //编辑出版社
// const $getPressList = (data) => http.post('/api/edu/publisher/selectPublisherPage', data); //查询出版社列表
const $getBookGroupList = (data) => http.post('/api/edu/bookgroup/getBookGroupListPage', data); //查询教材分类列表
const $getDropPressList = (data) => http.get('/api/edu/bookgroup/getPublisherList', data); //查询出版社下拉列表
const $addBookGroup = (data) => http.post('/api/edu/bookgroup/addBookGroup', data); //新增教材分类
const $editBookGroup = (data) => http.post('/api/edu/bookgroup/updateBookGroup', data); //编辑教材分类

export {
    $addPress,
    $editPress,
    // $getPressList,
    $getBookGroupList,
    $getDropPressList,
    $addBookGroup,
    $editBookGroup
}